/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Fab } from "@mui/material";
import NavigationIcon from "@mui/icons-material/Navigation";
import { useGoogleMap } from "@react-google-maps/api";
import { FC, useEffect, useRef } from "react";
import { useUserContext } from "context/UserContext";

export interface ResetMapHeadingProps {
  heading?: number;
}

export const ResetMapHeading: FC<ResetMapHeadingProps> = ({ heading = 0 }) => {
  const map = useGoogleMap();
  const { jobsite } = useUserContext();
  const ref = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (map) {
      const controls = map.controls[google.maps.ControlPosition.RIGHT_BOTTOM];
      if (ref.current) {
        const idx = controls
          .getArray()
          .findIndex((e) => e.id === "map-control-reset-head-icon");
        if (idx === -1) {
          // not found.
          controls.push(ref.current);
        } else {
          // replace
          controls.setAt(idx, ref.current);
        }
      }
    }
  }, [map]);

  useEffect(() => {
    if (map && jobsite?.jobSiteId) {
      map.setTilt(0);
      map.setHeading(heading);
    }
  }, [map, jobsite?.jobSiteId, heading]);

  const onClick = () => {
    if (map) {
      map.setTilt(0);
      map.setHeading(heading);
    }
  };

  return (
    <Fab id="map-control-reset-head-icon" ref={ref} onClick={onClick}>
      <NavigationIcon />
    </Fab>
  );
};
